var _path, _path2, _path3, _g, _g2, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g4, _path14, _g5, _path15, _g6, _path16, _path17, _path18, _path19, _path20, _g7, _path21, _g8, _path22, _g9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockedRewards(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4098 13.5453L61.8549 12.1189C63.7702 11.0594 65.5226 10.8556 66.8674 11.5484L69.3125 12.934L68.3345 12.9747C68.579 13.3823 68.742 13.7898 68.8642 14.2788C67.2749 14.3603 65.7263 14.6456 65.0335 15.7459C64.8705 15.6236 64.7075 15.5014 64.5445 15.4198L61.8141 18.5577L59.4098 17.2129V13.5453Z",
    fill: "url(#paint0_linear_1235:43293)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9213 31.9249C61.0812 30.6616 63.078 28.0535 63.9745 25.2823L65.6046 20.3106C66.1751 18.4767 66.0936 16.9282 65.3194 15.9909C65.2379 15.9094 65.1563 15.8279 65.0748 15.7464C65.7269 14.6868 67.3162 14.3608 68.9055 14.2793C69.3538 15.8686 69.1908 17.947 68.498 20.1883L67.1939 24.2228L67.6422 24.8341C67.6422 24.8341 64.5858 32.5769 64.4228 32.6584C64.3006 32.7399 62.915 33.0252 61.9777 33.1882C61.0404 34.1662 59.9808 34.9813 58.9213 35.5926L51.3007 39.9938V42.7242L48.8963 41.3793V37.7117L58.9213 31.9249Z",
    fill: "url(#paint1_linear_1235:43293)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3249 33.2694C63.4847 32.006 65.4816 29.3979 66.3781 26.6268L68.0082 21.6551C68.538 19.8212 68.4565 18.2726 67.6822 17.3353C66.9079 16.3981 65.6853 16.3165 64.259 17.1316L61.8139 18.5579V14.8902L64.259 13.4639C66.7449 12.0376 69.027 12.1598 70.3718 13.7899C71.7166 15.42 71.8796 18.3134 70.8608 21.492L69.2307 26.4638C67.8044 30.865 64.7073 34.9809 61.3249 36.937L51.2999 42.7238V39.0561L61.3249 33.2694Z",
    fill: "url(#paint2_linear_1235:43293)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2898 84.3838C36.978 84.3838 30.2398 82.2661 30.2398 79.6538C30.2398 77.0415 36.978 74.9238 45.2898 74.9238C53.6017 74.9238 60.3398 77.0415 60.3398 79.6538C60.3398 82.2661 53.6017 84.3838 45.2898 84.3838Z",
    fill: "url(#paint3_linear_1235:43293)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter1_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8445 84.7983C59.9431 87.428 53.0073 87.9657 52.3528 85.9993C51.6984 84.033 57.5732 80.3072 65.4746 77.6775C73.3759 75.0478 80.3118 74.5101 80.9662 76.4764C81.6206 78.4428 75.7458 82.1686 67.8445 84.7983Z",
    fill: "url(#paint4_linear_1235:43293)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7232 65.6273L32.4316 65.668C32.7169 65.4643 33.0022 65.3013 33.2874 65.1383C39.3595 61.6336 49.2214 61.6336 55.3342 65.1383C55.701 65.342 56.0678 65.5865 56.3938 65.8311L59.8984 65.8718V71.5363C59.8984 73.8184 58.3906 76.1413 55.3342 77.8936C49.2622 81.3983 39.4002 81.3983 33.2874 77.8936C30.231 76.1413 28.7232 73.8184 28.7232 71.5363V65.6273V65.6273Z",
    fill: "url(#paint5_linear_1235:43293)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3312 74.6335C35.7336 74.6335 28.7639 70.6012 28.7639 65.6273C28.7639 60.6533 35.7336 56.6211 44.3312 56.6211C52.9287 56.6211 59.8984 60.6533 59.8984 65.6273C59.8984 70.6012 52.9287 74.6335 44.3312 74.6335Z",
    fill: "url(#paint6_linear_1235:43293)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2872 71.9844C39.3593 75.4891 49.2212 75.4891 55.334 71.9844C58.2274 70.3136 59.7352 68.1537 59.8982 65.9531C60.0612 68.3575 58.5534 70.8026 55.334 72.6772C49.262 76.1819 39.4 76.1819 33.2872 72.6772C30.1086 70.8434 28.56 68.3982 28.723 65.9531C28.886 68.1537 30.3938 70.3136 33.2872 71.9844Z",
    fill: "url(#paint7_linear_1235:43293)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6933 63.1827L35.6933 63.1826C35.8971 63.0604 36.1008 62.9381 36.3046 62.7751C38.9038 61.2589 42.4696 60.6381 45.8602 60.9128C48.2237 61.0944 50.4979 61.7238 52.3202 62.7751C52.6054 62.9381 52.8499 63.1011 53.0945 63.2642H54.0725V68.5212C53.5835 68.9694 53.013 69.4177 52.3202 69.8252C51.5814 70.2514 50.7683 70.6034 49.9051 70.8845C45.5917 72.323 39.9812 71.9699 36.3046 69.8252C34.104 68.5619 33.0037 66.8911 33.0037 65.2203V63.1419L35.6933 63.1827ZM55.6211 63.2643H54.0725V68.5213C55.0913 67.5025 55.6211 66.3614 55.6211 65.2204V63.2643Z",
    fill: "url(#paint8_linear_1235:43293)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3328 69.6617C38.0985 69.6617 33.0445 66.7425 33.0445 63.1414C33.0445 59.5403 38.0985 56.6211 44.3328 56.6211C50.5672 56.6211 55.6211 59.5403 55.6211 63.1414C55.6211 66.7425 50.5672 69.6617 44.3328 69.6617Z",
    fill: "url(#paint9_linear_1235:43293)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3648 57.8013C47.0232 59.7167 41.6032 59.7167 38.2615 57.8013C34.9199 55.886 34.9199 52.7481 38.2615 50.792C41.6032 48.8766 47.0232 48.8766 50.3648 50.792C53.7065 52.7481 53.7065 55.886 50.3648 57.8013Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3162 59.27C52.5231 57.9252 52.8491 56.6211 52.8491 56.6211L51.5043 58.2512C47.3476 56.2543 41.2755 56.2543 37.1596 58.2512L35.774 56.6211C35.774 56.6211 36.1408 57.9252 34.307 59.27C32.5139 60.6148 33.0844 63.2229 33.0844 63.2229C33.0844 64.8937 34.1847 66.5238 36.3853 67.7871C40.7458 70.3138 47.8774 70.3138 52.2378 67.7871C54.4384 66.5238 55.5387 64.853 55.5387 63.2229C55.5387 63.2229 56.1092 60.6148 54.3162 59.27Z",
    fill: "url(#paint10_linear_1235:43293)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3648 59.7994C47.0232 61.7147 41.6032 61.7147 38.2615 59.7994C34.9199 57.884 34.9199 54.7461 38.2615 52.79C41.6032 50.8747 47.0232 50.8747 50.3648 52.79C53.7065 54.7461 53.7065 57.8433 50.3648 59.7994Z",
    fill: "url(#paint11_linear_1235:43293)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9207 22.918C22.1652 35.3881 28.5632 36.8959 32.0271 41.5824C35.2465 45.9428 34.8798 52.2594 34.7983 53.0744C34.7983 53.1152 34.7983 53.1559 34.7983 53.1559C34.7983 54.5822 35.7356 55.9678 37.5694 57.0273C41.2778 59.1872 47.3091 59.1872 51.0175 57.0273C52.7699 56.0085 53.6664 54.7045 53.7887 53.4004H53.8294V53.1559C53.8294 53.1152 53.8294 53.1152 53.8294 53.0744C53.7479 52.2594 53.3811 45.9428 56.6006 41.5824C60.0237 36.8959 66.4625 35.3881 66.707 22.918H21.9207V22.918Z",
    fill: "url(#paint12_linear_1235:43293)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2615 36.5294C38.2615 36.5294 38.7913 38.0372 40.4214 42.2754C42.0515 46.5544 41.2772 57.3536 41.2772 57.3536L38.506 57.5574C38.18 57.3944 37.854 57.2721 37.5687 57.0684C35.6941 56.0088 34.7976 54.5825 34.7976 53.1969C34.7976 53.1562 34.7976 53.1154 34.7976 53.1154C34.8791 52.3004 35.2459 45.9838 32.0265 41.6234C28.6033 36.9369 22.1645 35.4291 21.92 22.959H24.3651L38.2615 36.5294Z",
    fill: "url(#paint13_linear_1235:43293)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3325 35.8367C31.9539 35.8367 21.919 30.053 21.919 22.9184C21.919 15.7837 31.9539 10 44.3325 10C56.7112 10 66.7461 15.7837 66.7461 22.9184C66.7461 30.053 56.7112 35.8367 44.3325 35.8367Z",
    fill: "url(#paint14_linear_1235:43293)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1426 32.0872C51.381 37.1404 37.1993 37.1404 28.4784 32.0872C24.3624 29.7236 22.1618 26.6264 21.9581 23.5293C21.7135 27.034 23.8734 30.5794 28.4784 33.2283C37.24 38.2815 51.4217 38.2815 60.1426 33.2283C64.7476 30.5794 66.9482 26.9932 66.6629 23.5293C66.4592 26.6264 64.2586 29.6828 60.1426 32.0872Z",
    fill: "url(#paint15_linear_1235:43293)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3345 33.7582C33.9589 33.7582 25.5478 28.9049 25.5478 22.9181C25.5478 16.9314 33.9589 12.0781 44.3345 12.0781C54.71 12.0781 63.1211 16.9314 63.1211 22.9181C63.1211 28.9049 54.71 33.7582 44.3345 33.7582Z",
    fill: "url(#paint16_linear_1235:43293)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0082 16.2348C38.3436 11.9966 50.2431 11.9966 57.5785 16.2348C61.0424 18.2317 62.8762 20.799 63.08 23.4072C63.3245 20.473 61.4907 17.4981 57.5785 15.2568C50.2431 11.0186 38.3436 11.0186 31.0082 15.2568C27.1368 17.4981 25.3029 20.473 25.5067 23.4072C25.7512 20.799 27.585 18.2317 31.0082 16.2348Z",
    fill: "url(#paint17_linear_1235:43293)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1231 32.3735C40.8284 34.2074 47.8377 34.2074 53.543 32.3735C53.3392 32.2513 53.1354 32.129 52.9317 32.0068C48.2045 29.2764 40.5023 29.2764 35.7344 32.0068C35.4899 32.129 35.2861 32.2513 35.1231 32.3735Z",
    fill: "url(#paint18_linear_1235:43293)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8281 53.0747C53.8281 52.9932 53.8281 52.7894 53.7874 52.5449C53.6244 53.849 52.7278 55.0715 51.057 56.0903C47.3486 58.2502 41.3173 58.2502 37.6089 56.0903C35.938 55.1123 35.0415 53.8897 34.8377 52.6264C34.8377 52.8302 34.8377 52.9932 34.797 53.0747C34.797 53.1154 34.797 53.1562 34.797 53.1562C34.797 54.5825 35.7343 55.9681 37.5681 57.0276C41.2765 59.1875 47.3078 59.1875 51.0162 57.0276C52.7686 56.0088 53.6651 54.7048 53.7874 53.4007H53.8281V53.1562C53.8281 53.1562 53.8281 53.1154 53.8281 53.0747Z",
    fill: "url(#paint19_linear_1235:43293)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1612 50.9136C25.18 51.5656 26.6471 51.4841 28.1957 50.5876L38.2206 44.8008L40.625 46.1456L39.9322 47.3274L38.2206 47.7757V48.4277L28.1957 54.2145C27.0138 54.9073 25.9135 55.274 24.854 55.3555C23.3869 54.0922 23.5499 52.4622 24.1612 50.9136Z",
    fill: "url(#paint20_linear_1235:43293)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9804 39.9207C19.6747 40.4696 19.3959 41.0386 19.1488 41.6227C17.804 44.8014 17.641 47.8578 18.6598 49.9361L20.2898 53.0333C20.6974 53.8076 21.2679 54.4188 21.9199 54.8264L24.3243 56.1712L24.6096 55.4376H24.8948L24.6911 55.2339L24.8541 54.7856H24.3243C23.4685 53.6038 23.6723 52.2182 24.202 50.9142C23.7945 50.6289 23.4277 50.2621 23.1832 49.7731L21.5532 46.676C21.3086 46.1462 21.1864 45.5349 21.1864 44.8421L21.9607 45.2904L26.6471 38.5663L29.9481 35.0209L30.0703 34.1651L27.6659 32.8203L25.2208 34.2466C23.224 35.4284 21.3086 37.466 19.9638 39.9112L19.9804 39.9207Z",
    fill: "url(#paint21_linear_1235:43293)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 55.5996L40.625 49.8128V46.1451L30.6 51.9319C28.4402 53.1952 26.4433 52.8692 25.5468 51.1169L23.9167 48.0197C23.3462 46.8787 23.4277 45.2078 24.202 43.374C24.9763 41.5809 26.1988 40.0731 27.6251 39.2581L30.0702 37.8317V34.1641L27.6251 35.5904C25.1393 37.0167 22.8572 39.7878 21.5531 42.9665C20.2083 46.1451 20.0453 49.2423 21.0641 51.2391L22.6941 54.3363C24.0797 57.0667 27.2176 57.5557 30.6 55.5996Z",
    fill: "url(#paint22_linear_1235:43293)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6894 56.3848V77.2953C78.6894 77.7591 78.421 78.1843 77.8458 78.4935L60.6294 88.5043C59.4024 89.2387 57.2168 89.1227 55.798 88.3111C54.9928 87.8472 54.6094 87.2288 54.6094 86.6877V65.7771L78.6894 56.3848Z",
    fill: "url(#paint23_linear_1235:43293)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6298 67.594L77.8463 57.5832C79.0733 56.8488 78.9199 55.612 77.5012 54.7616C76.0824 53.9113 73.8968 53.834 72.6698 54.5684L55.4534 64.5792C54.2264 65.3135 54.3798 66.5504 55.7985 67.4007C57.2172 68.2124 59.4028 68.3284 60.6298 67.594Z",
    fill: "url(#paint24_linear_1235:43293)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9039 66.2411C59.7091 66.2411 60.3993 65.584 60.3993 64.7337V55.4573C60.3993 52.2878 62.7 48.2681 65.4224 46.6833L69.3718 44.3642C70.4071 43.7458 71.3657 43.5912 71.9409 43.9391C72.5544 44.2869 72.8994 45.1759 72.8994 46.4128V55.6892C72.8994 56.5009 73.5513 57.1966 74.3949 57.1966C75.2001 57.1966 75.8903 56.5395 75.8903 55.6892V46.4128C75.8903 44.055 75.0084 42.2771 73.4746 41.3494C71.9025 40.4218 69.947 40.5764 67.9147 41.7746L63.9653 44.0937C60.3226 46.2195 57.4468 51.2056 57.4468 55.4573V64.7337C57.4085 65.584 58.0987 66.2411 58.9039 66.2411Z",
    fill: "#F4F5FB"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1235:43293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 67,
    width: 10,
    height: 13
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9297 75.5362V74.9251C64.9297 71.7868 66.239 68.3473 69.283 67.584C70.2109 67.3513 71.1678 67.3318 72.0674 67.7087C73.9708 68.5062 74.3409 71.058 73.6535 73.1314C72.9662 75.2048 69.5295 76.507 69.5295 76.507V77.6498C69.5295 77.9535 69.4855 78.2213 69.4039 78.4589C68.5454 80.9572 64.9297 78.1779 64.9297 75.5362Z",
    fill: "#C4C4C4"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.0728 73.4281L72.5405 67.4163L76.7885 74.895L64.7098 82.2535L62.0728 73.4281Z",
    fill: "url(#paint25_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.0712,
    height: 8.60093,
    transform: "matrix(0.867162 -0.498026 0.493906 0.869515 62.3906 66.4102)",
    fill: "#00E5CC"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1235:43293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 67,
    width: 11,
    height: 14
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M65.375 76.0355V75.172C65.375 72.0338 66.6818 68.5618 69.7408 67.861C70.607 67.6625 71.4955 67.661 72.333 68.0119C74.1885 68.7893 74.5493 71.2769 73.8792 73.2981C73.2092 75.3193 69.859 76.5887 69.859 76.5887V77.7027C69.859 77.9876 69.7937 78.2611 69.6747 78.5217C68.5775 80.9248 65.375 78.6772 65.375 76.0355Z",
    fill: "#C4C4C4",
    stroke: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1558 76.1228H61.9727V69.8735C61.9727 67.6571 63.7627 65.8613 65.9722 65.8613H70.1558C72.9789 65.8613 75.2702 68.1599 75.2702 70.9921C75.2702 73.8242 72.9789 76.1228 70.1558 76.1228Z",
    fill: "url(#paint26_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7136 75.5011L66.7656 72.3916L65.0648 70.3704C65.0648 68.1539 63.9377 69.1266 66.1472 69.1266C66.1472 69.1266 65.6833 70.9923 68.7757 72.2361C71.8682 73.4799 73.1052 73.9464 74.0329 76.2785C74.0329 79.1107 74.5367 75.5011 71.7136 75.5011Z",
    fill: "url(#paint27_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9922 67.416C66.7504 68.2653 68.3713 69.3366 71.8615 70.0291C73.8746 70.4341 75.5085 71.2049 76.8158 72.0803C76.0184 69.3889 73.5086 67.416 70.5543 67.416H65.9922Z",
    fill: "url(#paint28_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9922 67.416C66.7504 68.2653 68.3713 69.3366 71.8615 70.0291C73.8746 70.4341 75.5085 71.2049 76.8158 72.0803C76.0184 69.3889 73.5086 67.416 70.5543 67.416H65.9922Z",
    fill: "url(#paint29_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6836 67.1055C66.4418 67.9547 68.0627 69.0261 71.5529 69.7185C73.566 70.1235 75.2 70.8944 76.5072 71.7698C75.7098 69.0783 73.2 67.1055 70.2457 67.1055H65.6836Z",
    fill: "url(#paint30_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.3008 67.1055C67.059 67.9547 68.6799 69.0261 72.1701 69.7185C74.1832 70.1235 75.8171 70.8944 77.1244 71.7698C76.327 69.0783 73.8172 67.1055 70.8629 67.1055H66.3008Z",
    fill: "url(#paint31_linear_1235:43293)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3125 68.193C68.8279 67.9857 70.4154 67.7266 70.7865 67.7266C71.2503 67.7266 73.5697 68.0375 74.0335 69.9032",
    stroke: "#00E5CC",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.375 72.3906V77.0728V78.4025C65.375 79.9383 66.9764 80.9403 68.3371 80.2567L68.7814 80.0319C71.003 78.9082 71.5918 75.9852 69.2406 75.1892C67.5559 74.6274 65.375 73.8983 65.375 72.3906Z",
    fill: "url(#paint32_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1626 72.0943C66.2662 71.1385 65.9785 69.8796 66.1488 69.2812C65.4134 69.833 65.0664 71.0297 65.0664 72.0244V76.7566H71.2588C72.1721 76.7566 73.0081 76.438 73.666 75.9096C73.3409 73.6096 70.7479 73.392 68.1626 72.0943Z",
    fill: "url(#paint33_linear_1235:43293)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.854 72.4049C65.9576 71.4491 65.5153 70.1901 65.6855 69.5918C64.9502 70.1435 64.7578 71.3403 64.7578 72.3349V77.0671H70.9502C71.8635 77.0671 72.6995 76.7485 73.3574 76.2201C73.0323 73.9201 70.4393 73.7025 67.854 72.4049Z",
    fill: "url(#paint34_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.304 74.413C65.0562 73.6146 63.9473 72.0573 64.1176 71.459C63.3822 72.0107 62.9023 72.8965 62.9023 73.8911V78.6234H69.0947C70.0081 78.6234 69.8209 78.6729 70.4788 78.1445C70.4788 75.6569 68.0049 75.5014 66.304 74.413Z",
    fill: "url(#paint35_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7578 73.0137V77.6959V79.0256C64.7578 80.5614 66.3592 81.5633 67.7199 80.8798L68.1643 80.655C70.3858 79.5313 70.9746 76.6082 68.6234 75.8122C66.9387 75.2504 64.7578 74.5213 64.7578 73.0137Z",
    fill: "url(#paint36_linear_1235:43293)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.7578 73.3242V78.0064V79.3361C64.7578 80.8719 65.7149 81.4364 67.0757 80.7528L68.1643 80.9655C70.3858 79.8418 70.9746 76.9188 68.6234 76.1228C66.9387 75.5609 64.7578 74.8319 64.7578 73.3242Z",
    fill: "url(#paint37_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0664 73.9453V77.547L65.0664 79.6829C65.0664 80.8642 65.7289 81.246 66.9037 80.7201C66.9037 80.7201 67.0821 80.7201 68.3012 79.6829C69.5203 78.6456 69.7051 76.8994 68.4681 76.2775C67.0137 75.8453 65.0664 75.1051 65.0664 73.9453Z",
    fill: "url(#paint38_linear_1235:43293)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_1235:43293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3828 74.7227C67.4859 75.4482 71.8669 76.5884 68.7744 79.6979",
    stroke: "url(#paint39_linear_1235:43293)",
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1235:43293",
    x: 22.2383,
    y: 66.9238,
    width: 46.1016,
    height: 25.4609,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1235:43293",
    x: 44.3047,
    y: 67.293,
    width: 44.7109,
    height: 27.8906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1235:43293",
    x: 27.7109,
    y: 64.9531,
    width: 33.1992,
    height: 11.3535,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1235:43293",
    x: 20.9375,
    y: 22.5293,
    width: 46.75,
    height: 15.4883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1235:43293",
    x: 24.4922,
    y: 11.0781,
    width: 39.6094,
    height: 13.3281,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1235:43293",
    x: 33.7969,
    y: 51.5449,
    width: 21.0312,
    height: 8.10352,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1235:43293",
    x: 57.4453,
    y: 40.75,
    width: 18.4453,
    height: 29.4902,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1235:43293",
    x: 63.9297,
    y: 66.416,
    width: 11.043,
    height: 14.0195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_1235:43293",
    x: 65.3008,
    y: 66.1055,
    width: 12.8242,
    height: 6.66406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1235:43293",
    x: 67.1641,
    y: 66.5762,
    width: 8.01953,
    height: 4.47656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1235:43293",
    x: 64.0664,
    y: 68.2812,
    width: 10.6016,
    height: 9.47461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_1235:43293",
    x: 63.7578,
    y: 72.0137,
    width: 7.375,
    height: 10.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_1235:43293",
    x: 66.3828,
    y: 73.7227,
    width: 4.49609,
    height: 6.97461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_1235:43293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1235:43293",
    x1: 63.1975,
    y1: 12.6408,
    x2: 63.3097,
    y2: 17.2565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484541,
    stopColor: "#569D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1235:43293",
    x1: 56.6455,
    y1: 20.0206,
    x2: 57.4519,
    y2: 37.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484541,
    stopColor: "#569D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1235:43293",
    x1: 57.4728,
    y1: 19.5219,
    x2: 58.4396,
    y2: 32.1834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#13C0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1235:43293",
    x1: 49.8704,
    y1: 82.5588,
    x2: 48.5383,
    y2: 78.0513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1235:43293",
    x1: 71.7416,
    y1: 81.9754,
    x2: 69.759,
    y2: 78.7501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1235:43293",
    x1: 55.9649,
    y1: 79.1982,
    x2: 35.1728,
    y2: 54.8685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1235:43293",
    x1: 50.5772,
    y1: 57.845,
    x2: 48.6759,
    y2: 76.4536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265323,
    stopColor: "#69D7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529957,
    stopColor: "#13C0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1235:43293",
    x1: 44.3108,
    y1: 65.9531,
    x2: 44.3108,
    y2: 75.3057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1235:43293",
    x1: 52.7673,
    y1: 70.9495,
    x2: 40.7244,
    y2: 54.0567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1235:43293",
    x1: 52.7725,
    y1: 68.7032,
    x2: 37.7201,
    y2: 51.0848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1235:43293",
    x1: 52.77,
    y1: 68.7221,
    x2: 37.6956,
    y2: 51.0662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1235:43293",
    x1: 46.3581,
    y1: 58.1845,
    x2: 36.8972,
    y2: 50.4106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1235:43293",
    x1: 61.0561,
    y1: 56.021,
    x2: 19.8682,
    y2: 21.1157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1235:43293",
    x1: 34.0251,
    y1: 46.8743,
    x2: 17.1431,
    y2: 42.3507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B28DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#9665FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#725BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1235:43293",
    x1: 51.1542,
    y1: 30.8523,
    x2: 45.5467,
    y2: 20.5054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E18BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302693,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9665FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1235:43293",
    x1: 44.3135,
    y1: 23.5293,
    x2: 44.3135,
    y2: 37.0182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1235:43293",
    x1: 58.3803,
    y1: 32.1646,
    x2: 33.3597,
    y2: 2.84787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1235:43293",
    x1: 44.2965,
    y1: 12.0781,
    x2: 44.2965,
    y2: 23.4072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1235:43293",
    x1: 51.2188,
    y1: 33.4703,
    x2: 48.7516,
    y2: 25.3633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#321DB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269097,
    stopColor: "#5742D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57118,
    stopColor: "#725BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825DCD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1235:43293",
    x1: 44.3125,
    y1: 52.5449,
    x2: 44.3125,
    y2: 58.6475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1235:43293",
    x1: 30.1831,
    y1: 46.9311,
    x2: 30.3163,
    y2: 53.5041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#569D95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E5CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1235:43293",
    x1: 22.6174,
    y1: 37.5334,
    x2: 23.5279,
    y2: 52.0239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22F4DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.354167,
    stopColor: "#008A7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#569D95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1235:43293",
    x1: 26.5782,
    y1: 39.4346,
    x2: 27.1204,
    y2: 48.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#13C0AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1235:43293",
    x1: 55.9325,
    y1: 76.9947,
    x2: 77.4146,
    y2: 72.7059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C93B43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361909,
    stopColor: "#FF4B55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF737B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1235:43293",
    x1: 51.0375,
    y1: 64.7553,
    x2: 93.9028,
    y2: 68.5845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB6168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435828,
    stopColor: "#FF9197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBDC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1235:43293",
    x1: 67.7735,
    y1: 80.4867,
    x2: 65.3703,
    y2: 74.2625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C31D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#2880FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1235:43293",
    x1: 68.776,
    y1: 69.1263,
    x2: 72.9521,
    y2: 72.8563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1235:43293",
    x1: 69.0415,
    y1: 73.2194,
    x2: 71.6469,
    y2: 70.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0885417,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364583,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1235:43293",
    x1: 68.0023,
    y1: 68.6598,
    x2: 73.5666,
    y2: 67.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#BBE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#01C5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1235:43293",
    x1: 68.0023,
    y1: 68.6598,
    x2: 73.5666,
    y2: 67.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#BBE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#0080EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729167,
    stopColor: "#01C5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1235:43293",
    x1: 67.8483,
    y1: 67.7274,
    x2: 73.7327,
    y2: 70.6639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#00E5CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789253,
    stopColor: "#10DCC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1235:43293",
    x1: 73.82,
    y1: 68.1921,
    x2: 71.0908,
    y2: 68.9594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9358,
    stopColor: "#C1FFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1235:43293",
    x1: 65.6842,
    y1: 74.4118,
    x2: 70.1376,
    y2: 76.8263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1235:43293",
    x1: 65.9941,
    y1: 70.5251,
    x2: 72.4872,
    y2: 75.6572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213542,
    stopColor: "#FCA8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869792,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1235:43293",
    x1: 66.6133,
    y1: 71.1466,
    x2: 70.4761,
    y2: 76.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1235:43293",
    x1: 64.7578,
    y1: 72.7028,
    x2: 68.6206,
    y2: 78.4573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F093FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1235:43293",
    x1: 65.2217,
    y1: 74.7239,
    x2: 70.1207,
    y2: 76.8075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120578,
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451663,
    stopColor: "#00B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1235:43293",
    x1: 67.6956,
    y1: 81.098,
    x2: 65.2397,
    y2: 75.3136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1235:43293",
    x1: 67.6027,
    y1: 79.9252,
    x2: 65.8647,
    y2: 75.331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2EAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9804,
    stopColor: "#E2F6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1235:43293",
    x1: 69.3929,
    y1: 76.4329,
    x2: 67.8323,
    y2: 80.0026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438179,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96858,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedRewards);
export default __webpack_public_path__ + "static/media/locked-rewards.85d2f204.svg";
export { ForwardRef as ReactComponent };